import type { GetCurrentMemberFn } from '@/features/iam'
import { createInternalFeatureLoader } from '@/utils/feature-loading-util'

export interface WaitlistFeatureOptions {
  getCurrentMember: GetCurrentMemberFn
}

/**
 * Everything related to waitlist feature.
 */
export type WaitlistFeature = ReturnType<typeof WaitlistFeature>

export function WaitlistFeature(options: WaitlistFeatureOptions) {
  const internal = createInternalFeatureLoader(
    () => import('./internal'),
    (module) => module.InternalWaitlistFeature(options),
  )

  return {
    internal,
  }
}
